/**
 * DB에 HTML 엔티티 문자열(&middot; &nbsp; &amp; 등)로 저장된 과거 데이터를
 * 화면에 표시할 때 실제 문자로 되돌린다.
 *
 * 구 JSP 화면은 브라우저가 엔티티를 해석해줬지만, React는 텍스트 노드를
 * 그대로 출력하므로 '&middot;'가 글자 그대로 보인다. 본문(nttCotClob)은
 * html-react-parser의 parse()가 처리하므로 대상이 아니고, 제목처럼
 * 순수 텍스트로 렌더링되는 값에만 사용한다.
 *
 * 디코딩 결과는 그대로 텍스트 노드로 렌더링되므로 XSS 위험은 없다.
 * (textarea는 내용을 RCDATA로 파싱해 태그를 element로 만들지 않는다)
 */

let decoder = null;

export function decodeHtmlEntities(value) {
    // 문자열이 아닌 값(숫자, JSX 엘리먼트 등)과 엔티티가 없는 값은 그대로 통과
    if (typeof value !== 'string' || !value.includes('&')) return value;
    if (typeof document === 'undefined') return value;

    if (!decoder) decoder = document.createElement('textarea');

    decoder.innerHTML = value;
    return decoder.value;
}
